import { RecoverPasswordContext } from '@/context/guest/Login/RecoverPassword'
import { useContext } from 'react'
import { RecoverPassword } from './RecoverPassword'
import { RecoveryCode } from '.'
import { ChangePassword } from './ChangePassword'

export const Bridge = () => {
  const { step } = useContext(RecoverPasswordContext)
  switch (step) {
    case 2:
      return <RecoveryCode />
    case 3:
      return <ChangePassword />
    default:
      return <RecoverPassword />
  }
}
